import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { betCodeAPI } from '../../api/endpoints';
import { FaCheck, FaTimes, FaFlag } from 'react-icons/fa';
import toast from 'react-hot-toast';
import './MarkBetCode.css';

const MarkBetCode = ({ betCodeId, onMarked }) => {
  const { isAuthenticated } = useAuth();
  const [loading, setLoading] = useState(false);
  const [showMark, setShowMark] = useState(false);
  const [selectedResult, setSelectedResult] = useState(null);
  const [placedBet, setPlacedBet] = useState(false);
  const [amount, setAmount] = useState('');

  if (!isAuthenticated) {
    return null;
  }

  const handleMark = async (result) => {
    setLoading(true);
    try {
      await betCodeAPI.mark(betCodeId, { 
        result,
        placed_bet: placedBet,
        amount: parseFloat(amount) || 0,
      });
      toast.success(`Bet code marked as ${result}!`);
      setShowMark(false);
      setSelectedResult(null);
      setPlacedBet(false);
      setAmount('');
      if (onMarked) onMarked();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to mark bet code');
    } finally {
      setLoading(false);
    }
  };

  if (!showMark) {
    return (
      <button 
        className="mark-bet-btn"
        onClick={() => setShowMark(true)}
      >
        <FaFlag /> Mark Bet Code
      </button>
    );
  }

  return (
    <div className="mark-bet-modal">
      <div className="mark-bet-content">
        <h3>Mark Bet Code Result</h3>
        <p>Did this bet code win or lose?</p>
        
        <div className="mark-bet-options">
          <button 
            className={`mark-option ${selectedResult === 'won' ? 'selected won' : ''}`}
            onClick={() => setSelectedResult('won')}
          >
            <FaCheck /> Won
          </button>
          <button 
            className={`mark-option ${selectedResult === 'loss' ? 'selected loss' : ''}`}
            onClick={() => setSelectedResult('loss')}
          >
            <FaTimes /> Lost
          </button>
        </div>

        {selectedResult && (
          <>
            <div className="mark-bet-details">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={placedBet}
                  onChange={(e) => setPlacedBet(e.target.checked)}
                />
                <span>I placed this bet</span>
              </label>
              {placedBet && (
                <div className="amount-input">
                  <label>Stake Amount ($XPUNT)</label>
                  <input
                    type="number"
                    placeholder="0.00"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    step="0.01"
                    min="0"
                  />
                </div>
              )}
            </div>

            <div className="mark-bet-actions">
              <button 
                className="btn btn-secondary"
                onClick={() => {
                  setShowMark(false);
                  setSelectedResult(null);
                  setPlacedBet(false);
                  setAmount('');
                }}
                disabled={loading}
              >
                Cancel
              </button>
              <button 
                className={`btn ${selectedResult === 'won' ? 'btn-success' : 'btn-danger'}`}
                onClick={() => handleMark(selectedResult)}
                disabled={loading}
              >
                {loading ? 'Processing...' : `Mark as ${selectedResult}`}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MarkBetCode;